// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiArray from "lumi-array/lib/es6/src/LumiArray.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";

function nonEmpty(v) {
  if (v === "") {
    return;
  } else {
    return v;
  }
}

function commonPrefix(boundary, _a, _b) {
  while (true) {
    let b = _b;
    let a = _a;
    if (a.length > b.length) {
      _b = a;
      _a = b;
      continue;
    }
    if (b.startsWith(a)) {
      return a;
    }
    let end = boundary !== undefined ? a.lastIndexOf(boundary, a.length - 2 | 0) + 1 | 0 : -1;
    _a = a.slice(0, end);
    continue;
  };
}

function commonPrefixArray(boundary, xs) {
  if (xs.length === 0) {
    return "";
  } else {
    return LumiArray.reduce1(xs, (extra, extra$1) => commonPrefix(boundary, extra, extra$1));
  }
}

let AnyToStringUnsupportedValue = /* @__PURE__ */Primitive_exceptions.create("LumiString.AnyToStringUnsupportedValue");

function anyToString(x) {
  let s = JSON.stringify(x);
  if (s !== undefined) {
    return s.substring(1, s.length - 1 | 0);
  }
  throw {
    RE_EXN_ID: AnyToStringUnsupportedValue,
    Error: new Error()
  };
}

function chunksOf(s, chunkSize) {
  return Belt_Array.rangeBy(0, s.length - 1 | 0, chunkSize).map(ix => s.substring(ix, ix + chunkSize | 0));
}

function concat(strings) {
  return "".concat(...strings);
}

export {
  nonEmpty,
  commonPrefix,
  commonPrefixArray,
  AnyToStringUnsupportedValue,
  anyToString,
  chunksOf,
  concat,
}
/* No side effect */
